import * as Yup from 'yup';

import { STATE_ABBREVIATIONS, STATES } from '@/mocks/states';

import { makeSelectString, optionalString, requiredNumber, requiredString } from './primitives';

export const locationSchema = Yup.object({
  addressLine1: requiredString,
  addressLine2: optionalString,
  city: requiredString,
  state: makeSelectString(STATE_ABBREVIATIONS),
  stateFullName: makeSelectString(Object.values(STATES)),
  zipCode: requiredString.max(5),
  country: requiredString,
  lat: requiredNumber,
  lon: requiredNumber,
});
